var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',[_vm._v(_vm._s(_vm.label))]),_c('vue-editor',{attrs:{"value":_vm.value},on:{"input":_vm.changeItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }